module.exports = __webpack_public_path__ + "static/media/create_group.0cde71e9.svg";